import { ProviderControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author rajkumar rathod
 */
export const useUpdateProviderUserAvatar = () =>
  useMutationWithLoading(
    async (params: {
      newavatar?: string;
      providerUuid?: string;
      xTENANTID?: string;
    }) =>
      new ProviderControllerApi(getConfigObject()).changeAvatar(
        {
          newAvatar: params?.newavatar,
          userId: params.providerUuid,
        },
        params.xTENANTID
      )
  );
